"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMergedRef = useMergedRef;
var _react = require("react");
const setRef = (ref, value) => {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    // React types assume ref is readonly
    // @ts-expect-error https://github.com/facebook/react/issues/13029#issuecomment-410002316
    // eslint-disable-next-line no-param-reassign
    ref.current = value;
  }
};

/**
 * useMergedRef
 * Merges multiple refs into a single function ref.
 * Takes any number of refs.
 * Refs can be mutable refs or function refs.
 * @param refs
 */
function useMergedRef(...refs) {
  return (0, _react.useMemo)(() => {
    if (refs.every(ref => ref === null)) {
      return null;
    }
    return refValue => {
      refs.forEach(ref => {
        if (ref) {
          setRef(ref, refValue);
        }
      });
    };
  }, [refs]);
}